function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SpinnerEl } from "common/components/spinner";
import { WizardBreadcrumbsEl } from "common/components/wizard-breadcrumbs";
import { thankYouView, thankYouViewMP2023 } from "./thank-you";
import { EnterpriseModal } from "./enterprise-modal";
import breadcrumbsMp23StyleOverride from "./breadcrumbs-mp23.inline.styl";
import breadcrumbsStyleOverride from "./breadcrumbs.inline.styl";
export function template() {
  const org = this.helpers.getOrgPlanInfo();
  const stepComponent = this.helpers.getCurrentStep() ? this.child(this.helpers.getCurrentStep().componentName, {
    attrs: _objectSpread({
      "mp-2023-style": this.attr("mp-2023-style")
    }, this.helpers.getCurrentStep().additionalComponentAttrs)
  }) : null;
  const isReady = this.helpers.isReady();
  if (this.state.showThankYou && isReady) {
    if (this.attr("mp-2023-style"))
      return thankYouViewMP2023(this.helpers.checkIfIntegrated());
    return thankYouView(this.helpers.getSelectedCapString(), this.helpers.getRenewalDate(), this.helpers.checkIfIntegrated());
  }
  return /* @__PURE__ */ jsx("div", { sel: this.attr("mp-2023-style") ? ".mp2023-plan-builder-wrapper" : ".plan-builder-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !isReady ? /* @__PURE__ */ jsx("div", { sel: ".spinner-wrapper" }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx("div", { sel: ".plan-builder" }, /* @__PURE__ */ jsx("div", { sel: ".left-pane" }, !this.attr("mp-2023-style") && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".org-title" }, (org === null || org === void 0 ? void 0 : org.orgName) || "Your New Organization"), /* @__PURE__ */ jsx("div", { sel: ".pane-title" }, "Build a Custom Plan")), /* @__PURE__ */ jsx("div", { sel: ".pane-breadcrumbs" }, /* @__PURE__ */ jsx(WizardBreadcrumbsEl, { attrs: {
    breadcrumbs: this.helpers.getBreadcrumbs(),
    "style-override": this.attr("mp-2023-style") ? breadcrumbsMp23StyleOverride : breadcrumbsStyleOverride
  }, on: {
    nodeClicked: this.helpers.handleBreadcrumbClick
  } })), /* @__PURE__ */ jsx("div", { sel: ".step-component-wrapper" }, stepComponent)), this.child("right-pane-2023", {
    attrs: {
      "mp-2023-style": this.attr("mp-2023-style")
    }
  }), EnterpriseModal(this.helpers.isEnterpriseCustomer() && !this.attr("force-org-choice"), this.helpers.trackContactSalesClicked, this.helpers.isNewStartupProgramCustomer(), org === null || org === void 0 ? void 0 : org.orgId)));
}
